import React from "react";
import "./HomeAbout.css";
import { useEffect, useRef, useState } from "react";
import smallImages from "../../assets/images/Travel/small img (1).png";
import big from '../../assets/images/Travel/big.png';

// import carimg from "../../assets/images/Home/about-h3-1.png";
// import smallImg from "../../assets/images/Home/about-h3-1-3.png";
// import groupImg from "../../assets/images/Home/Group-920.png";

// import { CardImg } from "react-bootstrap";
// const HomeAbout = () => {
//   return (
//     <section className="bg-white-50 rounded-lg py-12 px-4 flex justify-center">
//       <div className="max-w-screen-xl w-full flex flex-col md:flex-row items-center">
//         {/* Left Side: Images */}
//         <div className="md:w-1/2 flex justify-center relative mb-6 md:mb-0">
//           <div className="relative w-full md:w-[435px] md:h-[485px] left-side-images-container-home">
//             {/* Background Image */}
//             <div
//               className="absolute inset-0 rounded-lg overflow-hidden z-0"
//               style={{
//                 backgroundImage: `url(${carimg})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 width: "100%",
//                 height: "100%",
//               }}
//             />
//             {/* Foreground Small Image */}
//             <img
//               src={smallImg}
//               alt="Small decorative"
//               className="z-10 absolute top-[40%] left-[70%] w-16 h-16 md:w-[280px] md:h-[347px] object-contain"
//               style={{ zIndex: 2 }}
//             />
//             {/* Group Image and Text */}
//             <div className="absolute top-[95%] left-4 flex items-center gap-3 z-20 text-with-group-images bg-white/80 px-3 py-2 rounded-lg shadow pointer-events-auto">
//               <img
//                 src={groupImg}
//                 alt="Group"
//                 className="w-24 h-12 md:w-18 md:h-16 object-contain"
//               />
//               <span className="font-semibold text-base md:text-lg text-black">
//                 4M+ Clients Happy
//               </span>
//             </div>
//           </div>
//         </div>
//         {/* Right Side: Content */}
//         <div className="md:w-1/2 md:pl-14">
//           <div className="flex items-center mb-4">
//             <span className="inline-block bg-[#fff6f1] text-black-800 text-xs font-semibold px-2.5 py-0.5 rounded">
//               About Us
//             </span>
//           </div>
//           <h2 className="text-3xl font-bold text-gray-900 mb-4">
//             Secure Your Tomorrow With Our Insurance Services
//           </h2>
//           <p className="text-gray-600 mb-6">
//             Insurance is a financial arrangement that provides protection
//             against financial losses or risks. It is a contract between an
//             individual entity and an insurance company. In exchange for regular
//             payments known as premiums, the insurance company agrees.
//           </p>
//           <ul className="text-gray-700 mb-6 grid grid-cols-2 gap-x-8 gap-y-2 text-base">
//             <li className="flex items-center">
//               <span className="w-7 h-7 flex items-center justify-center mr-2 text-blue-600 text-lg font-bold">
//                 &#10003;
//               </span>
//               Local Knowledge
//             </li>
//             <li className="flex items-center">
//               <span className="w-7 h-7 flex items-center justify-center mr-2 text-blue-600 text-lg font-bold">
//                 &#10003;
//               </span>
//               Choice & Value
//             </li>
//             <li className="flex items-center">
//               <span className="w-7 h-7 flex items-center justify-center mr-2 text-blue-600 text-lg font-bold">
//                 &#10003;
//               </span>
//               Global Reach
//             </li>
//             <li className="flex items-center">
//               <span className="w-7 h-7 flex items-center justify-center mr-2 text-blue-600 text-lg font-bold">
//                 &#10003;
//               </span>
//               Fast Claims & Expert Support
//             </li>
//           </ul>
//           <p className="text-gray-600 mb-6">
//             Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.
//           </p>
//           <div className="flex flex-col sm:flex-row justify-between items-end gap-4">
//             <a
//               href="/about-us"
//               className="inline-block text-black border-2 border-[#1363df] font-medium py-2 px-6 rounded-lgg hover:bg-[#0f5abf] transition-colors duration-300"
//             >
//               Read More
//             </a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HomeAbout;
import "./HomeAbout.css";

const HomeAbout = () => {
  // Animation state for entrance
  const [visible, setVisible] = useState(false);
  // Counter states
  const [claim, setClaim] = useState(0);
  const [award, setAward] = useState(0);
  const [clients, setClients] = useState(0);

  // Target numbers
  const CLAIM_TARGET = 690000;
  const AWARD_TARGET = 120000;
  const CLIENTS_TARGET = 500000;

  // Ref for section
  const sectionRef = useRef(null);

  // Intersection Observer for entrance animation
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) {
        setVisible(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Animate counters when visible
  useEffect(() => {
    if (!visible) return;

    const duration = 3500;
    const steps = 100;
    const interval = duration / steps;
    let currentStep = 0;
    const claimStep = CLAIM_TARGET / steps;
    const awardStep = AWARD_TARGET / steps;
    const clientsStep = CLIENTS_TARGET / steps;

    const timer = setInterval(() => {
      currentStep++;
      setClaim((prev) => {
        const next = prev + claimStep;
        return next >= CLAIM_TARGET ? CLAIM_TARGET : next;
      });
      setAward((prev) => {
        const next = prev + awardStep;
        return next >= AWARD_TARGET ? AWARD_TARGET : next;
      });
      setClients((prev) => {
        const next = prev + clientsStep;
        return next >= CLIENTS_TARGET ? CLIENTS_TARGET : next;
      });
      if (currentStep >= steps) {
        clearInterval(timer);
        setClaim(CLAIM_TARGET);
        setAward(AWARD_TARGET);
        setClients(CLIENTS_TARGET);
      }
    }, interval);
    return () => clearInterval(timer);
  }, [visible]);
  return (
    <section
      ref={sectionRef}
      className="bg-white rounded-3xl pb-10 my-10 relative overflow-hidden home-about-section"
    >
      <div className="absolute inset-0 z-0" />
      <div className="relative z-0 max-w-screen-xl mx-auto flex flex-col md:flex-row gap-9 px-4">
        {/* Left Column - Images */}
        <div className="md:w-1/2 w-full flex flex-col justify-center relative min-h-[400px]">
          {/* Dot Image */}
          <img
            decoding="async"
            src="https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/about-h4-dot-1.png"
            alt="Decorative dot"
            loading="lazy"
            className={`relative right-[-1%] top-[51px] w-[138px] z-0 animate-float ${
              visible ? "fade-in-center" : ""
            }`}
          />
          {/* Main Image */}
          <img
            decoding="async"
            src={big}
            alt="Main visual"
            loading="lazy"
            width={526}
            height={560}
            className={`w-full max-w-[526px] h-[560px] rounded-lg block mx-auto relative z-9 ${
              visible ? "fade-in-center" : ""
            }`}
          />
          {/* Line Image */}
          <img
            decoding="async"
            src="https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/about-h4-line.png"
            alt="Decorative line"
            loading="lazy"
            className="animate-float-line relative left-[37%] bottom-[-2%] w-[120px] z-9 hidden md:block"
          />
          {/* Small Image */}
          <img
            decoding="async"
            // src="https://demo.rstheme.com/wordpress/insurigo/wp-content/uploads/2023/10/about-h4-sm1.png"
            src={smallImages}
            alt="Small accent"
            loading="lazy"
            className={`absolute right-0 bottom-[-40px] w-[300px] rounded-lg h-[280px] z-9999 hidden md:block ${
              visible ? "slide-up" : ""
            }`}
          />
        </div>
        {/* Right Column - Content */}
        <div className="md:w-1/2 w-full flex flex-col justify-center">
          {/* Heading */}
          <div className="mb-1">
            {/* <span className="inline-block text-[#000] font-semibold text-base mb-2 border-2 border-[#fe7c0b] rounded-[10px] px-3 py-1"> */}
            {/* <span className="inline-block aboutus-heading text-xs  px-4 py-1 rounded-full tracking-wide shadow-sm border border-[#e0e7ef]">
              About Us
            </span> */}
            <h2 className="text-2xl md:text-3xl font-black m-0 relative ">
              <span className="absolute left-0 opacity-10 text-4xl font-black"></span>
              Your Trusted Partner for Travel & Insurance Solutions
            </h2>
          </div>
          {/* Description */}
          <div className="mb-6 text-[#555] text-base leading-relaxed">
            <p>
              Across Assist is your trusted partner for all your travel and
              insurance needs. Whether you're planning an adventure abroad or
              seeking comprehensive protection for your family and assets, we
              make it easy to find the right coverage. Our team connects you
              with top insurance providers, ensuring you enjoy peace of mind on
              every journey and in every stage of life. Travel confidently and
              safeguard what matters most with our expert guidance and tailored
              insurance solutions.
            </p>
          </div>
          {/* Buttons */}
          <div className="flex gap-4 mb-6">
            <a
              href="/about-us"
              className="inline-flex items-center bg-white text-[#000] border-2 border-[#fe7c0b] rounded-lg px-6 py-2 font-semibold text-base transition-colors duration-200 hover:bg-[#1363df] hover:text-white hover:border-none"
            >
              Know More
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="12"
                viewBox="0 0 16 12"
                className="ml-2"
              >
                <path
                  d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
                  fill="#656567"
                ></path>
              </svg>
            </a>
            {/* <a
                            href="https://demo.rstheme.com/wordpress/insurigo/about"
                            className="inline-flex items-center bg-[#1363df] text-white border-2 border-[#1363df] rounded-lg px-6 py-2 font-semibold text-base transition-colors duration-200 hover:bg-[#0f5abf]"
                        >
                            Get offer save 50%
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                className="ml-2"
                            >
                                <path
                                    d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
                                    fill="#fff"
                                ></path>
                            </svg>
                        </a> */}
          </div>
          {/* Divider */}
          <div className="border-t border-gray-200 my-6" />
          {/* Counters */}
          <div className="flex flex-wrap gap-6">
            {/* Counter 1 */}
            <div className="flex items-center gap-4 flex-1 min-w-[120px]">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="40"
                  viewBox="0 0 23 30"
                  fill="none"
                >
                  <path
                    d="M23 1C23 0.447716 22.5523 0 22 0H17.5827C17.2226 0 16.8903 0.193655 16.7127 0.506987L0.84604 28.507C0.468281 29.1736 0.949836 30 1.71606 30H22C22.5523 30 23 29.5523 23 29V1Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M17.4974 26C17.959 26 18.3307 25.7116 18.3307 25.3586V21.6414C18.3307 21.2861 17.956 21 17.4974 21C17.0358 21 16.6641 21.2884 16.6641 21.6414V25.3586C16.6641 25.7139 17.0388 26 17.4974 26Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M15 23.4998C15 23.9615 15.2884 24.3332 15.6414 24.3332H19.3586C19.7139 24.3332 20 23.9585 20 23.4998C20 23.0382 19.7116 22.6665 19.3586 22.6665H15.6414C15.2861 22.6665 15 23.0412 15 23.4998Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M17.4974 14C17.959 14 18.3307 13.7116 18.3307 13.3586V9.64142C18.3307 9.28609 17.956 9 17.4974 9C17.0358 9 16.6641 9.2884 16.6641 9.64142V13.3586C16.6641 13.7139 17.0388 14 17.4974 14Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M15 11.4998C15 11.9615 15.2884 12.3332 15.6414 12.3332H19.3586C19.7139 12.3332 20 11.9585 20 11.4998C20 11.0382 19.7116 10.6665 19.3586 10.6665H15.6414C15.2861 10.6665 15 11.0412 15 11.4998Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M4 10C4.55395 10 5 9.65392 5 9.2303V4.7697C5 4.34331 4.55035 4 4 4C3.44605 4 3 4.34608 3 4.7697V9.2303C3 9.65669 3.44965 10 4 10Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M1 7C1 7.55395 1.34608 8 1.7697 8H6.23026C6.65666 8 7 7.55035 7 7C7 6.44605 6.65389 6 6.23026 6H1.7697C1.34331 6 1 6.44965 1 7Z"
                    fill="#fe7c0b"
                  ></path>
                </svg>
              </div>
              <div>
                <div className="about-number-font leading-tight">
                  <span className="text-black">{`${Math.floor(
                    claim / 1000
                  )}K+`}</span>
                </div>
                <div className="text-sm text-[#555]">Total Claim</div>
              </div>
            </div>
            {/* Counter 2 */}
            <div className="flex items-center gap-4 flex-1 min-w-[120px]">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="40"
                  viewBox="0 0 23 30"
                  fill="none"
                >
                  <path
                    d="M23 1C23 0.447716 22.5523 0 22 0H17.5827C17.2226 0 16.8903 0.193655 16.7127 0.506987L0.84604 28.507C0.468281 29.1736 0.949836 30 1.71606 30H22C22.5523 30 23 29.5523 23 29V1Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M17.4974 26C17.959 26 18.3307 25.7116 18.3307 25.3586V21.6414C18.3307 21.2861 17.956 21 17.4974 21C17.0358 21 16.6641 21.2884 16.6641 21.6414V25.3586C16.6641 25.7139 17.0388 26 17.4974 26Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M15 23.4998C15 23.9615 15.2884 24.3332 15.6414 24.3332H19.3586C19.7139 24.3332 20 23.9585 20 23.4998C20 23.0382 19.7116 22.6665 19.3586 22.6665H15.6414C15.2861 22.6665 15 23.0412 15 23.4998Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M17.4974 14C17.959 14 18.3307 13.7116 18.3307 13.3586V9.64142C18.3307 9.28609 17.956 9 17.4974 9C17.0358 9 16.6641 9.2884 16.6641 9.64142V13.3586C16.6641 13.7139 17.0388 14 17.4974 14Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M15 11.4998C15 11.9615 15.2884 12.3332 15.6414 12.3332H19.3586C19.7139 12.3332 20 11.9585 20 11.4998C20 11.0382 19.7116 10.6665 19.3586 10.6665H15.6414C15.2861 10.6665 15 11.0412 15 11.4998Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M4 10C4.55395 10 5 9.65392 5 9.2303V4.7697C5 4.34331 4.55035 4 4 4C3.44605 4 3 4.34608 3 4.7697V9.2303C3 9.65669 3.44965 10 4 10Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M1 7C1 7.55395 1.34608 8 1.7697 8H6.23026C6.65666 8 7 7.55035 7 7C7 6.44605 6.65389 6 6.23026 6H1.7697C1.34331 6 1 6.44965 1 7Z"
                    fill="#fe7c0b"
                  ></path>
                </svg>
              </div>
              <div>
                <div className="about-number-font text-[#222]">
                  <span>{`${Math.floor(award / 1000)}K+`}</span>
                </div>
                <div className="text-sm text-[#555]">Award Winning</div>
              </div>
            </div>
            {/* Counter 3 */}
            <div className="flex items-center about-number-font gap-4 flex-1 min-w-[120px]">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="40"
                  viewBox="0 0 23 30"
                  fill="none"
                >
                  <path
                    d="M23 1C23 0.447716 22.5523 0 22 0H17.5827C17.2226 0 16.8903 0.193655 16.7127 0.506987L0.84604 28.507C0.468281 29.1736 0.949836 30 1.71606 30H22C22.5523 30 23 29.5523 23 29V1Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M17.4974 26C17.959 26 18.3307 25.7116 18.3307 25.3586V21.6414C18.3307 21.2861 17.956 21 17.4974 21C17.0358 21 16.6641 21.2884 16.6641 21.6414V25.3586C16.6641 25.7139 17.0388 26 17.4974 26Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M15 23.4998C15 23.9615 15.2884 24.3332 15.6414 24.3332H19.3586C19.7139 24.3332 20 23.9585 20 23.4998C20 23.0382 19.7116 22.6665 19.3586 22.6665H15.6414C15.2861 22.6665 15 23.0412 15 23.4998Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M17.4974 14C17.959 14 18.3307 13.7116 18.3307 13.3586V9.64142C18.3307 9.28609 17.956 9 17.4974 9C17.0358 9 16.6641 9.2884 16.6641 9.64142V13.3586C16.6641 13.7139 17.0388 14 17.4974 14Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M15 11.4998C15 11.9615 15.2884 12.3332 15.6414 12.3332H19.3586C19.7139 12.3332 20 11.9585 20 11.4998C20 11.0382 19.7116 10.6665 19.3586 10.6665H15.6414C15.2861 10.6665 15 11.0412 15 11.4998Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M4 10C4.55395 10 5 9.65392 5 9.2303V4.7697C5 4.34331 4.55035 4 4 4C3.44605 4 3 4.34608 3 4.7697V9.2303C3 9.65669 3.44965 10 4 10Z"
                    fill="#fe7c0b"
                  ></path>
                  <path
                    d="M1 7C1 7.55395 1.34608 8 1.7697 8H6.23026C6.65666 8 7 7.55035 7 7C7 6.44605 6.65389 6 6.23026 6H1.7697C1.34331 6 1 6.44965 1 7Z"
                    fill="#fe7c0b"
                  ></path>
                </svg>
              </div>
              <div>
                <div className="about-number-font">
                  <span>{`${Math.floor(clients / 1000)}K+`}</span>
                </div>
                <div className="text-sm text-[#555]"> Worldwide Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
